exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-align-right {\n  text-align: right;\n  -ms-flex-pack: end;\n      justify-content: flex-end; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/caixa/auditoria-caixa/auditoria-caixa.component.scss
// module id = ../../../../../src/app/components/caixa/auditoria-caixa/auditoria-caixa.component.scss
// module chunks = main